import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { hasSubscription } from 'redux/query';
import AdvantagesSection from './AdvantagesSection';
import BenefitInfoSection from './BenefitInfoSection';
import CtaInfoSection from './CtaInfoSection';
import { HealthInsuranceSection } from './HealthInsuranceSection';
import MobileShowcaseSection from './MobileShowcaseSection';
import PodcastSection from './PodcastSection';
import Stage from './Stage';
import TrustBandSection from './TrustBandSection';
import { VideoSection } from './VideoSection';
import { HealthInsuranceSliderSection } from './HealthInsuranceSliderSection';

export const Home = () => {
  const subscribed = useSelector(hasSubscription);
  return (
    <main className="home">
      <FormattedMessage id="meta.title">
        {(title) => (
          <Helmet>
            <title>{title}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <Stage hasSubscription={subscribed} />
      <AdvantagesSection />
      <HealthInsuranceSection />
      <HealthInsuranceSliderSection />
      <VideoSection />
      <PodcastSection />
      <BenefitInfoSection hasSubscription={subscribed} />
      <MobileShowcaseSection />
      <TrustBandSection />
      <CtaInfoSection />
    </main>
  );
};

export default Home;
